import { Field, Int, ObjectType } from '@nestjs/graphql'
import { UserEmailDto } from './userEmail.dto'
import { BaseModelWithoutUserDto } from '../base/baseModelWithoutUser.dto'
import { UserPreferencesDto } from './preferences'
import { ArcClaimDto } from '../arc/claim'
import { BasicUserDto } from './basicModel.dto'

@ObjectType()
export class UserDto extends BaseModelWithoutUserDto {
  @Field({ nullable: true })
  emailAddress?: string

  @Field({ nullable: true })
  termsConsentDate?: Date

  @Field(t => UserPreferencesDto, { nullable: true })
  preferences?: UserPreferencesDto

  @Field(type => Int, { nullable: true })
  consentMethod?: number

  @Field({ nullable: true })
  termsConsentRevokedDate?: Date

  @Field(type => String, { nullable: true })
  reviewerRole?: string

  @Field(type => String, { nullable: true })
  authorRole?: string

  @Field(t => Int, { nullable: true })
  selectedPrimaryRole?: number

  @Field(t => String, { nullable: true })
  name?: string

  @Field(t => String, { nullable: true })
  image?: string

  @Field(t => String, { nullable: true })
  kindleEmail?: string

  @Field({ nullable: true })
  verifiedKindleEmail?: boolean

  @Field(t => String, { nullable: true })
  amazonProfileLink?: string

  @Field(t => [UserEmailDto], { nullable: true })
  userEmails?: UserEmailDto[]

  @Field(t => [UserDto], { nullable: true })
  following?: UserDto[]

  @Field(t => [BasicUserDto], { nullable: true })
  canActAs?: BasicUserDto[]

  // NOTE: This "could" be an array of BasicUserDto but we're not technically supporting
  // multiple VAs per user (although the code works this way) so we're just sending down
  // the first VA the user added.
  @Field({ nullable: true })
  hasActingAs?: string

  @Field(type => Int, { nullable: true })
  status?: number

  @Field(t => [ArcClaimDto], { nullable: true })
  arcClaims?: ArcClaimDto[]

  @Field({ nullable: true })
  topReviewerAppStatusDate?: Date

  @Field(type => Int, { nullable: true })
  topReviewerAppStatus?: number

  @Field({ nullable: true })
  topReviewerAppStatusReason?: string

  @Field({ nullable: true })
  isAdmin?: boolean

  @Field(type => Int, { nullable: true })
  pirateReportCount?: number

  @Field({ nullable: true })
  unsubId?: string

  @Field({ nullable: true })
  stripeCustomerId?: string

  @Field({ nullable: true })
  isLocked?: boolean

  @Field({ nullable: true })
  completedTours?: string

  @Field(t => Int, { nullable: true })
  cancelReason?: number

  @Field({ nullable: true })
  cancelReasonDescription?: string

  @Field({ nullable: true })
  forceLoyaltyDiscountView?: boolean

  @Field({ nullable: true })
  countryCode?: string

  @Field({ nullable: true })
  lastLoginDate?: Date

  // comma separated list
  @Field({ nullable: true })
  usedCouponCodes?: string

  @Field({ nullable: true })
  phoneNumber?: string

  @Field({ nullable: true })
  phoneVerified?: boolean

  @Field({ nullable: true })
  firstPromoterId?: string

  @Field({ nullable: true })
  legacyBestsellingArcs?: boolean

  // Staff-set; null = the plan's own limit. See PermissionService.effectiveLimit
  @Field(type => Int, { nullable: true })
  maxRunningArcsOverride?: number | null

  @Field({ nullable: true })
  requiresPhoneVerification?: boolean
}
